import styled from 'styled-components';

export const ContainerPagination = styled.div`
	background-color: white;
	margin-bottom: 20px;
	margin-top: 11px;
	border-radius: 7px;
	padding: 10px;
`;
